<template>
  <div>
    <page-header>
      <h2>Дневник ЛРАС</h2>
      <template  #actions>        
        <div class="d-flex align-items-baseline actions">
          <div class="mx-2">
            <div class="search-filed">
              <component-input
                :maxNumberLength="6"
                @keyupEnter="onFiltersApply()"
                v-model="filters.searchRegNumber"
                placeholder="Введите рег.номер для поиска..."
              />
              <div
                @click="
                  filters.searchRegNumber = '';
                  onFiltersApply();
                "
                v-if="filters.searchRegNumber && filters.searchRegNumber.length"
                class="cross"
              >
                <icon-component name="cross" />
              </div>
              <button
                type="button"
                class="btn btn-default"
                v-on:click="onFiltersApply()"
              >
                <icon-component name="searchSvg" />
              </button>
            </div>
          </div>
          <div class="search-wrapper mx-2">
            <div class="search-tooltip"><sup><i class="fa fa-info-circle text-gray" :title="searchTooltip"></i></sup></div>
            <div class="search-filed">
              <component-input @keyupEnter="filters.searchRegNumber = '';onFiltersApply()" v-model="filters.searchText" placeholder="Введите данные для поиска..."></component-input>
              <div @click="filters.searchText = '';onFiltersApply();" v-if="filters.searchText && filters.searchText.length" class="cross"><icon-component name="cross"/></div>
              <button type="button" class="btn btn-default" v-on:click="filters.searchRegNumber = '';onFiltersApply()">
              <icon-component name="searchSvg"/>
              </button>
            </div>
            <div
              v-if="keyboardSuggestion"
              class="search-suggestion"
            >
              Возможно, вы имели в виду:
              <span
                class="search-suggestion-link"
                @click="applySuggestion"
              >
                {{ keyboardSuggestion }}
              </span>
            </div>
          </div>

          <button-component kind="primary" type="button" v-on:click="importIppsuAll" class="mx-2" v-if="canImport">Импорт ИППСУ</button-component>          
          <button-component class="button-component_success mx-2" @click="exportExcel()" title="Экспорт в эксель">
            <template v-if="!exportInProgress"><i class="fa fa-download" style="color:#fff"></i></template>
            <template v-else><i class="fa fa-spinner fa-spin" style="color:#fff"></i></template>
          </button-component>
          <button-component
            kind="tertiary"
            :class="{ filtered: isFiltered }"
            @click="modals.filter = !modals.filter"
          >
            <template #prepend>
              <icon-component class="mr-2" name="filter" />
            </template>
            Фильтр
          </button-component>
        </div>
      </template>
    </page-header>

    <section class="content">
      <template v-if="page.items?.length">
        <div class="table-inner ">
          <table class="table-custom">
            <thead>
              <tr>
                <th width="50px"></th>
                <th class="text-center">№</th>
                <!-- <th></th> -->
                <th>ФИО</th>
                <th>СНИЛС</th>
                <th>Дата рождения</th>
                <th>
                  Статус изменений
                  <i
                    style="cursor: pointer"
                    @click="columnSort('Patient.ChangeStatusId')"
                    class="ml-2 fas text-gray fa-sort-amount-down-alt"
                    :class="{
                      'fas text-black fa-sort-amount-up':
                        sortMode && sortColumn === 'Patient.ChangeStatusId',
                      'text-black': sortColumn === 'Patient.ChangeStatusId',
                    }"
                  ></i>
                </th>
                <th>
                  Дата изменений
                  <i
                    style="cursor: pointer"
                    @click="columnSort('Patient.ChangeStatusDate')"
                    class="ml-2 fas text-gray fa-sort-amount-down-alt"
                    :class="{
                      'fas text-black fa-sort-amount-up':
                        sortMode && sortColumn === 'Patient.ChangeStatusDate',
                      'text-black': sortColumn === 'Patient.ChangeStatusDate',
                    }"
                  ></i>
                </th>
                <th>
                  Период ИМАР
                  <i
                    style="cursor: pointer"
                    @click="columnSort('ImarDateEnd')"
                    class="ml-2 fas text-gray fa-sort-amount-down-alt"
                    :class="{
                      'fas text-black fa-sort-amount-up':
                        sortMode && sortColumn === 'ImarDateEnd',
                      'text-black': sortColumn === 'ImarDateEnd',
                    }"
                  ></i>
                </th>
                <th class="text-center">ИППСУ</th>
                <th class="text-center">ПМПК</th> 
                                
                <!-- <th>Свидетельство о рождении</th>
                <th>Паспортные данные</th> -->
                <th class="text-center">ИМАР</th>
                <th class="text-center">ИПРА</th>    
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in page.items"
                :key="item.id"
                v-on:dblclick="editCard(item.patient.id, item.isDeletedPermanently)"
                :class="[isModfiedClass(item?.isChangeStatus,'tr',item?.changeStatusDate), { deletedPerm: item?.isDeletedPermanently } ]"
              >
                <!-- item.modified -->
                <td>
                  <menu-component class="actions" :actions="actions(item)" />
                </td>
                <td class="text-center">{{ page.firstItemNumber + index }}</td>
                <!-- <td class="text-center">
                  <i
                    class="fas fa-bell"
                    title="Новый дневник"
                    v-if="item.isNew"
                  ></i>
                </td> -->
                <td>
                  {{ item.patient.surname }} {{ item.patient.name }}
                  {{ item.patient.patronimic }}
                </td>
                <td>{{ item.patient.snils }}</td>
                <td>
                  {{ $momentFormat(item.patient.dateOfBirth, "DD.MM.YYYY") }}
                </td>
                <td>
                  <template v-if="item?.changeStatusName">
                    <span
                      :class="isModfiedClass(item?.isChangeStatus,'td')"
                      @click="openModified(item?.changeStatusId, item)"
                    >
                      {{ item?.changeStatusName }}
                    </span>
                  </template>
                  <template v-else>
                    -
                  </template>
                </td>
                <td>
                  {{ item?.changeStatusDate ? $momentFormat(item?.changeStatusDate, "DD.MM.YYYY") : '-' }}
                </td>
                <td>
                  {{ item?.imarDateEnd ? $momentFormat(item?.imarDateEnd, "DD.MM.YYYY") : '-' }}
                </td>
                <td class="text-center">
                  <button
                    :disabled="!item.hasIppsu"
                    class="btn"
                    @click="
                      item.hasIppsu ? openIppsu(item) : null
                    "
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 17 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.0586 0.633301C15.4753 0.633301 15.8294 0.779134 16.1211 1.0708C16.4128 1.36247 16.5586 1.71663 16.5586 2.1333V13.1333C16.5586 13.55 16.4128 13.9041 16.1211 14.1958C15.8294 14.4875 15.4753 14.6333 15.0586 14.6333H2.05859C1.64193 14.6333 1.28776 14.4875 0.996094 14.1958C0.704427 13.9041 0.558594 13.55 0.558594 13.1333V2.1333C0.558594 1.71663 0.704427 1.36247 0.996094 1.0708C1.28776 0.779134 1.64193 0.633301 2.05859 0.633301H15.0586ZM14.8711 13.1333C14.9961 13.1333 15.0586 13.0708 15.0586 12.9458V2.3208C15.0586 2.1958 14.9961 2.1333 14.8711 2.1333H2.24609C2.12109 2.1333 2.05859 2.1958 2.05859 2.3208V12.9458C2.05859 13.0708 2.12109 13.1333 2.24609 13.1333H14.8711ZM13.5586 10.2583V11.0083C13.5586 11.2583 13.4336 11.3833 13.1836 11.3833H6.93359C6.68359 11.3833 6.55859 11.2583 6.55859 11.0083V10.2583C6.55859 10.0083 6.68359 9.8833 6.93359 9.8833H13.1836C13.4336 9.8833 13.5586 10.0083 13.5586 10.2583ZM13.5586 7.2583V8.0083C13.5586 8.2583 13.4336 8.3833 13.1836 8.3833H6.93359C6.68359 8.3833 6.55859 8.2583 6.55859 8.0083V7.2583C6.55859 7.0083 6.68359 6.8833 6.93359 6.8833H13.1836C13.4336 6.8833 13.5586 7.0083 13.5586 7.2583ZM13.5586 4.2583V5.0083C13.5586 5.2583 13.4336 5.3833 13.1836 5.3833H6.93359C6.68359 5.3833 6.55859 5.2583 6.55859 5.0083V4.2583C6.55859 4.0083 6.68359 3.8833 6.93359 3.8833H13.1836C13.4336 3.8833 13.5586 4.0083 13.5586 4.2583ZM5.33984 3.85205C5.56901 4.06038 5.68359 4.3208 5.68359 4.6333C5.68359 4.9458 5.56901 5.21663 5.33984 5.4458C5.13151 5.65413 4.87109 5.7583 4.55859 5.7583C4.24609 5.7583 3.97526 5.65413 3.74609 5.4458C3.53776 5.21663 3.43359 4.9458 3.43359 4.6333C3.43359 4.3208 3.53776 4.06038 3.74609 3.85205C3.97526 3.62288 4.24609 3.5083 4.55859 3.5083C4.87109 3.5083 5.13151 3.62288 5.33984 3.85205ZM5.33984 6.85205C5.56901 7.06038 5.68359 7.3208 5.68359 7.6333C5.68359 7.9458 5.56901 8.21663 5.33984 8.4458C5.13151 8.65413 4.87109 8.7583 4.55859 8.7583C4.24609 8.7583 3.97526 8.65413 3.74609 8.4458C3.53776 8.21663 3.43359 7.9458 3.43359 7.6333C3.43359 7.3208 3.53776 7.06038 3.74609 6.85205C3.97526 6.62288 4.24609 6.5083 4.55859 6.5083C4.87109 6.5083 5.13151 6.62288 5.33984 6.85205ZM5.33984 9.85205C5.56901 10.0604 5.68359 10.3208 5.68359 10.6333C5.68359 10.9458 5.56901 11.2166 5.33984 11.4458C5.13151 11.6541 4.87109 11.7583 4.55859 11.7583C4.24609 11.7583 3.97526 11.6541 3.74609 11.4458C3.53776 11.2166 3.43359 10.9458 3.43359 10.6333C3.43359 10.3208 3.53776 10.0604 3.74609 9.85205C3.97526 9.62288 4.24609 9.5083 4.55859 9.5083C4.87109 9.5083 5.13151 9.62288 5.33984 9.85205Z"
                        :fill="item.hasIppsu ? '#438EF0' : '#ABABB3'"
                      />
                    </svg>
                  </button>
                </td>
                <td class="text-center">
                  <button
                    :disabled="!item.hasPmpkConclusion"
                    class="btn"
                    @click="
                      item.hasPmpkConclusion ? openPmpkConclusion(item) : null
                    "
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 17 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.0586 0.633301C15.4753 0.633301 15.8294 0.779134 16.1211 1.0708C16.4128 1.36247 16.5586 1.71663 16.5586 2.1333V13.1333C16.5586 13.55 16.4128 13.9041 16.1211 14.1958C15.8294 14.4875 15.4753 14.6333 15.0586 14.6333H2.05859C1.64193 14.6333 1.28776 14.4875 0.996094 14.1958C0.704427 13.9041 0.558594 13.55 0.558594 13.1333V2.1333C0.558594 1.71663 0.704427 1.36247 0.996094 1.0708C1.28776 0.779134 1.64193 0.633301 2.05859 0.633301H15.0586ZM14.8711 13.1333C14.9961 13.1333 15.0586 13.0708 15.0586 12.9458V2.3208C15.0586 2.1958 14.9961 2.1333 14.8711 2.1333H2.24609C2.12109 2.1333 2.05859 2.1958 2.05859 2.3208V12.9458C2.05859 13.0708 2.12109 13.1333 2.24609 13.1333H14.8711ZM13.5586 10.2583V11.0083C13.5586 11.2583 13.4336 11.3833 13.1836 11.3833H6.93359C6.68359 11.3833 6.55859 11.2583 6.55859 11.0083V10.2583C6.55859 10.0083 6.68359 9.8833 6.93359 9.8833H13.1836C13.4336 9.8833 13.5586 10.0083 13.5586 10.2583ZM13.5586 7.2583V8.0083C13.5586 8.2583 13.4336 8.3833 13.1836 8.3833H6.93359C6.68359 8.3833 6.55859 8.2583 6.55859 8.0083V7.2583C6.55859 7.0083 6.68359 6.8833 6.93359 6.8833H13.1836C13.4336 6.8833 13.5586 7.0083 13.5586 7.2583ZM13.5586 4.2583V5.0083C13.5586 5.2583 13.4336 5.3833 13.1836 5.3833H6.93359C6.68359 5.3833 6.55859 5.2583 6.55859 5.0083V4.2583C6.55859 4.0083 6.68359 3.8833 6.93359 3.8833H13.1836C13.4336 3.8833 13.5586 4.0083 13.5586 4.2583ZM5.33984 3.85205C5.56901 4.06038 5.68359 4.3208 5.68359 4.6333C5.68359 4.9458 5.56901 5.21663 5.33984 5.4458C5.13151 5.65413 4.87109 5.7583 4.55859 5.7583C4.24609 5.7583 3.97526 5.65413 3.74609 5.4458C3.53776 5.21663 3.43359 4.9458 3.43359 4.6333C3.43359 4.3208 3.53776 4.06038 3.74609 3.85205C3.97526 3.62288 4.24609 3.5083 4.55859 3.5083C4.87109 3.5083 5.13151 3.62288 5.33984 3.85205ZM5.33984 6.85205C5.56901 7.06038 5.68359 7.3208 5.68359 7.6333C5.68359 7.9458 5.56901 8.21663 5.33984 8.4458C5.13151 8.65413 4.87109 8.7583 4.55859 8.7583C4.24609 8.7583 3.97526 8.65413 3.74609 8.4458C3.53776 8.21663 3.43359 7.9458 3.43359 7.6333C3.43359 7.3208 3.53776 7.06038 3.74609 6.85205C3.97526 6.62288 4.24609 6.5083 4.55859 6.5083C4.87109 6.5083 5.13151 6.62288 5.33984 6.85205ZM5.33984 9.85205C5.56901 10.0604 5.68359 10.3208 5.68359 10.6333C5.68359 10.9458 5.56901 11.2166 5.33984 11.4458C5.13151 11.6541 4.87109 11.7583 4.55859 11.7583C4.24609 11.7583 3.97526 11.6541 3.74609 11.4458C3.53776 11.2166 3.43359 10.9458 3.43359 10.6333C3.43359 10.3208 3.53776 10.0604 3.74609 9.85205C3.97526 9.62288 4.24609 9.5083 4.55859 9.5083C4.87109 9.5083 5.13151 9.62288 5.33984 9.85205Z"
                        :fill="item.hasPmpkConclusion ? '#438EF0' : '#ABABB3'"
                      />
                    </svg>
                  </button>
                </td>
                
                <!-- <td>
                  {{ item.patient.birthCertSerie }}
                  {{ item.patient.birthCertNum }}
                  {{ $momentFormat(item.patient.birthCertDt, "DD.MM.YYYY") }}
                </td>
                <td>
                  {{ item.patient.passportSerie }}
                  {{ item.patient.passportNum }}
                </td> -->
                <td class="text-center">
                  <button
                    :disabled="!item.hasImar"
                    class="btn"
                    @click="
                      item.hasImar ? openImar(item) : null
                    "
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 17 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.0586 0.633301C15.4753 0.633301 15.8294 0.779134 16.1211 1.0708C16.4128 1.36247 16.5586 1.71663 16.5586 2.1333V13.1333C16.5586 13.55 16.4128 13.9041 16.1211 14.1958C15.8294 14.4875 15.4753 14.6333 15.0586 14.6333H2.05859C1.64193 14.6333 1.28776 14.4875 0.996094 14.1958C0.704427 13.9041 0.558594 13.55 0.558594 13.1333V2.1333C0.558594 1.71663 0.704427 1.36247 0.996094 1.0708C1.28776 0.779134 1.64193 0.633301 2.05859 0.633301H15.0586ZM14.8711 13.1333C14.9961 13.1333 15.0586 13.0708 15.0586 12.9458V2.3208C15.0586 2.1958 14.9961 2.1333 14.8711 2.1333H2.24609C2.12109 2.1333 2.05859 2.1958 2.05859 2.3208V12.9458C2.05859 13.0708 2.12109 13.1333 2.24609 13.1333H14.8711ZM13.5586 10.2583V11.0083C13.5586 11.2583 13.4336 11.3833 13.1836 11.3833H6.93359C6.68359 11.3833 6.55859 11.2583 6.55859 11.0083V10.2583C6.55859 10.0083 6.68359 9.8833 6.93359 9.8833H13.1836C13.4336 9.8833 13.5586 10.0083 13.5586 10.2583ZM13.5586 7.2583V8.0083C13.5586 8.2583 13.4336 8.3833 13.1836 8.3833H6.93359C6.68359 8.3833 6.55859 8.2583 6.55859 8.0083V7.2583C6.55859 7.0083 6.68359 6.8833 6.93359 6.8833H13.1836C13.4336 6.8833 13.5586 7.0083 13.5586 7.2583ZM13.5586 4.2583V5.0083C13.5586 5.2583 13.4336 5.3833 13.1836 5.3833H6.93359C6.68359 5.3833 6.55859 5.2583 6.55859 5.0083V4.2583C6.55859 4.0083 6.68359 3.8833 6.93359 3.8833H13.1836C13.4336 3.8833 13.5586 4.0083 13.5586 4.2583ZM5.33984 3.85205C5.56901 4.06038 5.68359 4.3208 5.68359 4.6333C5.68359 4.9458 5.56901 5.21663 5.33984 5.4458C5.13151 5.65413 4.87109 5.7583 4.55859 5.7583C4.24609 5.7583 3.97526 5.65413 3.74609 5.4458C3.53776 5.21663 3.43359 4.9458 3.43359 4.6333C3.43359 4.3208 3.53776 4.06038 3.74609 3.85205C3.97526 3.62288 4.24609 3.5083 4.55859 3.5083C4.87109 3.5083 5.13151 3.62288 5.33984 3.85205ZM5.33984 6.85205C5.56901 7.06038 5.68359 7.3208 5.68359 7.6333C5.68359 7.9458 5.56901 8.21663 5.33984 8.4458C5.13151 8.65413 4.87109 8.7583 4.55859 8.7583C4.24609 8.7583 3.97526 8.65413 3.74609 8.4458C3.53776 8.21663 3.43359 7.9458 3.43359 7.6333C3.43359 7.3208 3.53776 7.06038 3.74609 6.85205C3.97526 6.62288 4.24609 6.5083 4.55859 6.5083C4.87109 6.5083 5.13151 6.62288 5.33984 6.85205ZM5.33984 9.85205C5.56901 10.0604 5.68359 10.3208 5.68359 10.6333C5.68359 10.9458 5.56901 11.2166 5.33984 11.4458C5.13151 11.6541 4.87109 11.7583 4.55859 11.7583C4.24609 11.7583 3.97526 11.6541 3.74609 11.4458C3.53776 11.2166 3.43359 10.9458 3.43359 10.6333C3.43359 10.3208 3.53776 10.0604 3.74609 9.85205C3.97526 9.62288 4.24609 9.5083 4.55859 9.5083C4.87109 9.5083 5.13151 9.62288 5.33984 9.85205Z"
                        :fill="item.hasImar ? '#438EF0' : '#ABABB3'"
                      />
                    </svg>
                  </button>
                </td>
                <td class="text-center">
                  <button
                    :disabled="!item.hasIpra"
                    class="btn"
                    @click="
                      item.hasIpra ? openIpra(item) : null
                    "
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 17 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.0586 0.633301C15.4753 0.633301 15.8294 0.779134 16.1211 1.0708C16.4128 1.36247 16.5586 1.71663 16.5586 2.1333V13.1333C16.5586 13.55 16.4128 13.9041 16.1211 14.1958C15.8294 14.4875 15.4753 14.6333 15.0586 14.6333H2.05859C1.64193 14.6333 1.28776 14.4875 0.996094 14.1958C0.704427 13.9041 0.558594 13.55 0.558594 13.1333V2.1333C0.558594 1.71663 0.704427 1.36247 0.996094 1.0708C1.28776 0.779134 1.64193 0.633301 2.05859 0.633301H15.0586ZM14.8711 13.1333C14.9961 13.1333 15.0586 13.0708 15.0586 12.9458V2.3208C15.0586 2.1958 14.9961 2.1333 14.8711 2.1333H2.24609C2.12109 2.1333 2.05859 2.1958 2.05859 2.3208V12.9458C2.05859 13.0708 2.12109 13.1333 2.24609 13.1333H14.8711ZM13.5586 10.2583V11.0083C13.5586 11.2583 13.4336 11.3833 13.1836 11.3833H6.93359C6.68359 11.3833 6.55859 11.2583 6.55859 11.0083V10.2583C6.55859 10.0083 6.68359 9.8833 6.93359 9.8833H13.1836C13.4336 9.8833 13.5586 10.0083 13.5586 10.2583ZM13.5586 7.2583V8.0083C13.5586 8.2583 13.4336 8.3833 13.1836 8.3833H6.93359C6.68359 8.3833 6.55859 8.2583 6.55859 8.0083V7.2583C6.55859 7.0083 6.68359 6.8833 6.93359 6.8833H13.1836C13.4336 6.8833 13.5586 7.0083 13.5586 7.2583ZM13.5586 4.2583V5.0083C13.5586 5.2583 13.4336 5.3833 13.1836 5.3833H6.93359C6.68359 5.3833 6.55859 5.2583 6.55859 5.0083V4.2583C6.55859 4.0083 6.68359 3.8833 6.93359 3.8833H13.1836C13.4336 3.8833 13.5586 4.0083 13.5586 4.2583ZM5.33984 3.85205C5.56901 4.06038 5.68359 4.3208 5.68359 4.6333C5.68359 4.9458 5.56901 5.21663 5.33984 5.4458C5.13151 5.65413 4.87109 5.7583 4.55859 5.7583C4.24609 5.7583 3.97526 5.65413 3.74609 5.4458C3.53776 5.21663 3.43359 4.9458 3.43359 4.6333C3.43359 4.3208 3.53776 4.06038 3.74609 3.85205C3.97526 3.62288 4.24609 3.5083 4.55859 3.5083C4.87109 3.5083 5.13151 3.62288 5.33984 3.85205ZM5.33984 6.85205C5.56901 7.06038 5.68359 7.3208 5.68359 7.6333C5.68359 7.9458 5.56901 8.21663 5.33984 8.4458C5.13151 8.65413 4.87109 8.7583 4.55859 8.7583C4.24609 8.7583 3.97526 8.65413 3.74609 8.4458C3.53776 8.21663 3.43359 7.9458 3.43359 7.6333C3.43359 7.3208 3.53776 7.06038 3.74609 6.85205C3.97526 6.62288 4.24609 6.5083 4.55859 6.5083C4.87109 6.5083 5.13151 6.62288 5.33984 6.85205ZM5.33984 9.85205C5.56901 10.0604 5.68359 10.3208 5.68359 10.6333C5.68359 10.9458 5.56901 11.2166 5.33984 11.4458C5.13151 11.6541 4.87109 11.7583 4.55859 11.7583C4.24609 11.7583 3.97526 11.6541 3.74609 11.4458C3.53776 11.2166 3.43359 10.9458 3.43359 10.6333C3.43359 10.3208 3.53776 10.0604 3.74609 9.85205C3.97526 9.62288 4.24609 9.5083 4.55859 9.5083C4.87109 9.5083 5.13151 9.62288 5.33984 9.85205Z"
                        :fill="item.hasIpra ? '#438EF0' : '#ABABB3'"
                      />
                    </svg>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="page.pagesTotal > 1">
          <Pagination
            :page-count="page.pagesTotal"
            :current-page="page.pageNumber"
            @change="onPageChange($event)"
          />
        </div>
        <div>
          <PageCounter :isFiltered="isFiltered" :totalCount="totalCount" :filteredCount="page.itemsTotal" />
        </div>
      </template>
      <template v-else>
        <EmptyListMessage />
      </template>
      <section class="modals">
        <transition name="filter">
          <div class="filter" v-if="modals.filter">
            <JournalsFilters
              v-bind:filters="filters"
              v-on:apply="onFiltersApply($event)"
              v-on:reset="onFiltersReset($event)"
            />
          </div>
        </transition>
        <modal-component
          class="modal-content--card"
          v-if="modals.pmpkConclustion.show"
          :title="modals.pmpkConclustion.fio + ' &mdash; Заключение ПМПК'"
          @close="modals.pmpkConclustion.show = false"
        >
          <!-- <pmpk-conclusion
            :patient-id="modals.pmpkConclustion.patientId"
            @close="modals.pmpkConclustion.show = false"
          /> -->
          <pmpk-conclusion-active
            :patient-id="modals.pmpkConclustion.patientId"
            @close="modals.pmpkConclustion.show = false"
          />
        </modal-component>

        <modal-component
          class="modal-content--card"
          v-if="modals.ippsu.show"
          :title="modals.ippsu.fio + ' &mdash; ИППСУ'"
          @close="modals.ippsu.show = false"
        >
          <ippsu-modal-card
            :journalId="modals.ippsu.journalId"
            :patientId="modals.ippsu.patientId"
            @close="modals.ippsu.show = false"
          />
        </modal-component>

        <modal-component
          class="modal-content--card"
          v-if="modals.ipra.show"
          :title="modals.ipra.fio + ' &mdash; ИПРА'"
          @close="modals.ipra.show = false"
        >
          <ipra-modal-card
            :id="modals.ipra.id"
            @close="modals.ipra.show = false"
          />
        </modal-component>

        <modal-component
          class="modal-content--card"
          v-if="modals.imar.show"
          :title="modals.imar.fio + ' &mdash; ИМАР'"
          @close="modals.imar.show = false"
        >
          <imar-modal-card
            :journal-id="modals.imar.journalId"
            :route-id="modals.imar.journalRouteId"
            @close="modals.imar.show = false"
          />
        </modal-component>

        <modal-component v-if="modals.shortPatientCard" size-class="modal-xl" title="" @close="modals.shortPatientCard = false">
          <patient-short-card :id="modals.shortPatientCardId" @close="modals.shortPatientCard = false" />
        </modal-component>
      </section>
    </section>
  </div>
</template>

<script>
import moment from 'moment';
import API from "../api/journal";
import apiIppsu from "../api/ippsu";
import apiPatientChange from '@/common/api/patientChange';
import JournalsFilters from "../components/JournalsFilters.vue";
import ButtonComponent from "@/common/ui/ButtonComponent";
import ComponentInput from "@/common/components/ComponentInput";
import PageHeader from "@/common/components/page/PageHeader";
import IconComponent from "@/common/ui/IconComponent";
import Constants from "../../../common/constants";
import MenuComponent from "@/common/ui/components/page/MenuComponent";
import filtermanager from "../../../common/mixins/filtermanager";
import security from "../../../common/mixins/security";
import ModalComponent from "@/common/ui/ModalComponent";
//import PmpkConclusion from "../../ras/components/PmpkConclusion";
import PmpkConclusionActive from "../../ras/components/PmpkConclusionActive";
import IpraModalCard from "../components/IpraModalCard";
import IppsuModalCard from "../components/IppsuModalCard";
import ImarModalCard from "../components/ImarModalCard";
import PatientShortCard from "@/modules/ras/components/PatientShortCard";
import PageCounter from "@/common/components/PageCounter";
import userManager from "../../auth/user-manager";
import Utils from "@/common/utils";

export default {
  name: "Journals",
  components: {
    MenuComponent,
    IconComponent,
    PageHeader,
    ButtonComponent,
    ComponentInput,
    JournalsFilters,
    ModalComponent,
    //PmpkConclusion,
    PmpkConclusionActive,
    IpraModalCard,
    IppsuModalCard,
    ImarModalCard,
    PatientShortCard,
    PageCounter
  },
  mixins: [filtermanager, security],
  created() {
    //загрузить по-умолчанию
    this.request.pageNumber = this.$route.query.page1 ? this.$route.query.page1 * 1 : 1;
    const self = this;
    API.search({ pageNumber: 1, pageSize: 1, isDeletedPermanently: false }).then(function (response) {
      self.totalCount = response.data.itemsTotal;
    });
    
    this.getAccessMatrix(
      this.viewPermissions.concat(this.editPermissions)
    ).then(response => {
      this.accessMatrix = response.data;
    });
    this.checkPermission(Constants.PatientDeletePermanentlyView).then((response) => {
      this.canViewDeletedPermanently = response.data;
      this.loadPage();
    });

    userManager.getUser().then((user) => {
      this.canImport = user.profile.role.indexOf(Constants.AdminRoleId) > -1;
    });
  },
  data: () => ({
    request: {
      pageNumber: 1,
      pageSize: Constants.pageSize
    },
    filters: {
      FIO: "",
      dateOfBirth: null,
      docType: 0,
      docSerieNum: "",
      isConfirmed: null,
      districtId: 0,
      imarOrgId: 0,
      age: null,
      hasImar: null,
      male: null,
      searchText: "",
      searchRegNumber: "",
      periodFrom: null,
      periodTo: null,
      imarPeriodFrom: null,
      imarPeriodTo: null,
      hasDiagnostics: 1,
      imarStatusIds: [],
      imarServiceIds: [],
      ippsuStatusIds: [],
      ipraStatusId: null,
      hasPmpk: null,
      isDeletedPermanently: false
    },
    page: {},
    modals: {
      filter: false,
      pmpkConclustion: {
        patientId: null,
        show: false
      },
      ippsu: {
        journalId: null,     
        patientId: null,   
        show: false
      },
      ipra: {
        id: null,
        show: false
      },
      imar: {
        journalRouteId: null,
        journalId: null,
        show: false
      },
      shortPatientCard: false,
      shortPatientCardId: null,
    },
    patient: null,
    isFiltered: false,
    isLastFiltered: false,
    viewPermissions: [
      Constants.JournalRouteView,
      Constants.JournalImarView,
      Constants.IPPSUView,
      Constants.PMPKView,
      Constants.IPRAView,
      Constants.MedServiceView,
      Constants.JournalDiagnosticView
    ],
    editPermissions: [
      Constants.JournalRouteEdit,
      Constants.JournalImarEdit,
      Constants.IPPSUEdit,
      Constants.PMPKEdit,
      Constants.IPRAEdit,
      Constants.MedServiceEdit,
      Constants.JournalDiagnosticEdit
    ],
    accessMatrix: {},
    totalCount: 0,
    canViewDeletedPermanently: false,
    canImport: false,
    exportInProgress: false,
    sortMode: false,
    sortColumn: "",
    canMarkAsRead: null,
    searchTooltip: Constants.searchTooltip
  }),
  methods: {
    exportExcel() {
      if (this.exportInProgress) return;

      const filter = this.loadFilter();
      if (filter) {
        this.filters = filter;
        this.isFiltered = true;
      }
      const params = Object.assign({}, this.filters, {
        sortColumn: this.sortColumn,
        sortMode: this.sortMode,
      });
      if (params.hasDiagnostics == 1) delete params.hasDiagnostics;
      if (!this.canViewDeletedPermanently) params.isDeletedPermanently = false;

      this.exportInProgress = true;
      API.exportFile(params)
        .catch(() => Constants.alert.fire("Экспорт", "Произошла ошибка", "error"))
        .finally(() => { this.exportInProgress = false; });
    },
    importIppsuAll() {
      apiIppsu.importAllData().then((response) => {
        console.log(response.data);
        Constants.alert.fire('Импорт', 'Импорт успешно запущен. Результаты будут присланы системными сообщениями', 'info');
      });
    },

    actions(item) {
      let result = [];
      if (this.canView()) {
        result.push({
          title: "Просмотр",
          icon: "eye",
          click: () => this.viewCard(item.patient.id)
        });
      }
      if (this.canEdit() && !item.isDeletedPermanently) {
        result.push({
          title: "Редактировать",
          icon: "pen",
          click: () => this.editCard(item.patient.id, item.isDeletedPermanently)
        });
      }
      result.push({
        title: "Обновить",
        icon: "refresh",
        click: () => this.refreshCard(item.id)
      });
      result.push({
          title: 'Карточка',
          icon: 'table-document-icon',
          click: () => this.shortCard(item.patient.id)
        });
      return result;
    },
    onPageChange(pageNumber) {
      this.request.pageNumber = pageNumber;
      this.$router.push({
        query: {
          ...this.$route.query,
          page1: pageNumber
        }
      });
      this.loadPage();
    },
    loadPage() {
      const filter = this.loadFilter();
      if (filter) {
        this.filters = filter;
        this.isFiltered = true;
      }
      if (this.filters.hasDiagnostics == 1) delete this.filters.hasDiagnostics;
      var params = Object.assign(this.filters, this.request, {
        sortColumn: this.sortColumn,
        sortMode: this.sortMode,
      });
      if(!this.canViewDeletedPermanently)//видит только архивные
        params.isDeletedPermanently = false;
      API.search(params).then(response => {
        this.page = response.data;
      });
      this.checkPermission(Constants.DiagnosesEdit).then((response) => {
        this.canMarkAsRead = response.data;
      });
    },
    onFiltersApply(filters) {
      const regNumber = this.filters.searchRegNumber?.trim();
      const searchText = this.filters.searchText?.trim();

      if (filters) {
        this.filters = filters;
        this.hideFilters = filters;
        this.isFiltered = true;
        this.isLastFiltered = true;
        this.filters.searchText = "";
        this.filters.searchRegNumber = "";
        this.saveFilter(this.filters);     
      } else if (!regNumber && !searchText) {
        this.filters = Object.assign({}, this.hideFilters);
        this.isFiltered = this.isLastFiltered;
        
        this.filters.searchText = "";
        this.filters.searchRegNumber = "";

        if(this.isFiltered)
          this.saveFilter(this.filters);        
      } else {
        if (regNumber) {
          this.filters = {
            searchRegNumber: regNumber,
          };
        } else {
          this.filters = {
            searchText: searchText,
          };
        }
        
        this.isFiltered = false;
        this.removeFilter();
      }
      this.modals.filter = false;
      this.request.pageNumber = 1;
      this.loadPage();
    },
    onFiltersReset(filters) {
      this.filters = filters || {};
      this.hideFilters = filters || {};
      this.request.pageNumber = 1;
      this.modals.filter = false;
      this.removeFilter();
      this.isFiltered = false;
      this.isLastFiltered = false;
      this.loadPage();
    },
    viewCard(id, tab) {
      this.patient = id;
      this.modals.view = true;
      var params =  { action: "view", id: id };
      if(tab)
        params.tab = tab;
      this.$router.push({
        name: "journalCard",
        params: params,
        query: { page1: this.request.pageNumber }
      });
    },
    shortCard(id) {
      this.modals.shortPatientCardId = id;
      this.modals.shortPatientCard = true;
    },
    editCard(id, isDelete) {
      if (this.canEdit() && !isDelete) {
        this.$router.push({
          name: "journalCard",
          params: { action: "edit", id: id },
          query: { page1: this.request.pageNumber }
        });
      } else if (this.canView()) {
        this.viewCard(id);
      }
    },
    openPmpkConclusion(item) {
      this.modals.pmpkConclustion.patientId = item.patient.id;
      this.modals.pmpkConclustion.fio =
        item.patient.surname +
        " " +
        item.patient.name +
        (item.patient.patronimic ? " " + item.patient.patronimic : "");
      this.modals.pmpkConclustion.show = true;
    },
    openImar(item) {
      this.modals.imar.journalId = item.id;
      this.modals.imar.journalRouteId = item.journalRouteId;
      this.modals.imar.fio =
        item.patient.surname +
        " " +
        item.patient.name +
        (item.patient.patronimic ? " " + item.patient.patronimic : "");
      this.modals.imar.show = true;   
    },
    openIpra(item) {
      // if(this.canView()) {
      //   this.viewCard(id, "tab4");
      // } 
      this.modals.ipra.id = item.ipraId;
      this.modals.ipra.fio =
        item.patient.surname +
        " " +
        item.patient.name +
        (item.patient.patronimic ? " " + item.patient.patronimic : "");
      this.modals.ipra.show = true; 
    },
    openIppsu(item) {
      this.modals.ippsu.journalId = item.id;
      this.modals.ippsu.patientId = item.patient.id;
      this.modals.ippsu.fio =
        item.patient.surname +
        " " +
        item.patient.name +
        (item.patient.patronimic ? " " + item.patient.patronimic : "");
      this.modals.ippsu.show = true;
    },
    refreshCard(id) {
      //обновление из сторонних источников
      console.log(id);
    },
    canView() {
      let canView = false;
      this.viewPermissions.forEach(item => {
        if (this.accessMatrix[item]) {
          canView = true;
        }
      });
      return canView;
    },
    canEdit() {
      let canEdit = false;
      this.editPermissions.forEach(item => {
        if (this.accessMatrix[item]) {
          canEdit = true;
        }
      });
      return canEdit;
    },
    isModfiedClass(item,block, dateChange) {
      if (item == true) {
        if (block === 'tr' && moment().startOf('day').diff(moment(dateChange).startOf('day'), 'days') < 14)//подсвечивать красным не более 14 дней
          return 'modified';
        else if (block === 'td')
          return 'marker-new cursor-pointer';
      } else {
        return '';
      }
    },
    goByStatusIdToCard(currentCard,currentItem,currentStatusId) {
      if(this.canMarkAsRead){
        apiPatientChange.patientChangeRead(currentItem.patient.id).then(response => {
          let res = response;
          console.log(res+'res read')
        });
      }
      var pageProps = currentCard == 'journalCard'
        ? { page1: this.request.pageNumber }
        : { page: this.request.pageNumber };

      if (this.canEdit()) {
        this.$router.push({
          name: currentCard,
          params: {
            action: "edit",
            id: currentItem.patient.id,
            statusOfChangeId: currentStatusId
          },
          query: pageProps
        });
      } else if (this.canView()) {
        this.$router.push({
          name: currentCard,
          params: {
            action: "view",
            id: currentItem.patient.id,
            statusOfChangeId: currentStatusId
          },
          query: pageProps
        });
      }
    },
    openModified(statusOfChangeId,item) {
      switch (statusOfChangeId){
        case 1:
        case 2:
        case 3:
        case 4:
        case 6:
        case 7:
        case 9:
          this.goByStatusIdToCard('journalCard', item, statusOfChangeId);
          break;
        case 5:
        case 8:
          this.goByStatusIdToCard('patientCard', item, statusOfChangeId);
          break;
        default:
          break
      }
    },
    columnSort(sortColumn) {
      if (this.sortColumn !== sortColumn) {
        this.sortMode = sortColumn == "Patient.ChangeStatusDate" ? true : false;
      } else this.sortMode = !this.sortMode;

      this.sortColumn = sortColumn;

      this.loadPage();
    },
    applySuggestion() {
      this.filters.searchText = this.keyboardSuggestion;
      this.filters.searchRegNumber = "";
      this.onFiltersApply();
    }
  },
  watch: {
    '$route.query.page1': {
      handler(newVal) {
        this.request.pageNumber = newVal ? newVal * 1 : 1;
        this.loadPage();
      }
    }
  },
  computed: {
    keyboardSuggestion() {
      const text = this.filters.searchText?.trim();
      if (!text) {
        return null;
      }

      // есть ли латинские буквы
      if (!/[a-z]/i.test(text)) {
        return null;
      }

      const converted = Utils.enToRu(text);

      return converted !== text
        ? converted
        : null;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";

.content {
  padding: 16px 16px 0 16px;
  position: relative;

  .filter {
    position: absolute;
    width: 350px;
    height: auto;
    top: 0;
    right: 0;
    overflow: hidden;
    background-color: transparent;
    opacity: 1;
    transition: opacity 0.2s;
  }

  .filter-enter, .filter-leave-to /* .fade-leave-active below version 2.1.8 */
 {
    opacity: 0;
  }
  .table-inner {
    overflow: auto;
  }
}

tr.deletedPerm td {
  color: $gray-dark;
  font-style: italic;
}

.fas {
  color: $gray-medium;
}
.filtered {
  color: $red;
  &:hover {
    color: $red-dark;
  }
}
::-webkit-scrollbar {
  width: 0;
}

.search-filed {
  position: relative;
  width: 320px !important;
  input {
    height: 100%;
  }
  .cross {
    cursor: pointer;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 60px;
    .icon {
      width: 10px;
      height: 10px;
    }
  }
  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    background-color: #438ef0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
  .icon {
    width: 20px;
    height: 23px;
  }
  }
}

.search-wrapper {
  display: inline-block;
  position: relative;
}
.search-tooltip {
  position: absolute;
  left: 3px;
  top: 1px;
  z-index: 1;
  // opacity: 0.5;

  // &:hover {
  //   opacity: 1;
  // }
}
</style>
